import { createFileRoute } from '@tanstack/react-router'
import { ContactsPage } from '@/pages/contacts'

export const Route = createFileRoute('/_authenticated/contacts/')({
  staticData: { title: 'Contacts' },
  component: ContactsPage,
})
